module.exports = __webpack_public_path__ + "static/r15-5b81c07a5c02c6962100f475558b9ab9.jpg";